import Member3D from "./Member3D";
import { Canvas } from "@react-three/fiber";
import { useRef, useState, useEffect, useMemo } from "react";
import Fuse from "fuse.js";
import { AutoComplete } from "antd";
import "./MemberCanvas.css";

// 引导弹窗组件
function Member3DIntroduction({ onClose }) {
    return (
        <>
            <div className="member3d-intro-overlay" onClick={onClose} />
            <div className="member3d-intro-container">
                <button className="member3d-intro-close" onClick={onClose}>
                    ✕
                </button>
                <h3> 使用指南 </h3>
                <p>🎮 鼠标拖动/屏幕滑动可以旋转视角</p>
                <p>🔍 滚轮滚动/缩放手势可以拉近拉远视角</p>
                <p>💻 （仅限电脑端）鼠标悬浮在头像上可以显示成员名</p>
                <p>✨ 点击成员头像可以让视角跟随头像，再点击任意区域可以取消跟随</p>
                <p>🔎 左下角的右箭头按键可以打开搜索界面，可以快捷锁定某个成员</p>
                <div className="member3d-intro-footer">
                    写不动了让ai写的引导窗，凑合看看吧（小声）
                </div>
            </div>
        </>
    );
}

export default Member3DIntroduction;